// extracted by mini-css-extract-plugin
export default {"stickToTop":"StickyContainer_stickToTop--G96","stickToHeader":"StickyContainer_stickToHeader--PPH"};